var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLiquidExpose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.368 48.5518H9",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.684 52.2363C22.9747 52.2363 23.2103 52.472 23.2103 52.7626V52.7626C23.2103 53.0533 22.9747 53.2889 22.684 53.2889V53.2889C22.3934 53.2889 22.1577 53.0533 22.1577 52.7626V52.7626C22.1577 52.472 22.3934 52.2363 22.684 52.2363",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.368 38.0259V52.7625C36.368 55.0879 34.4829 56.973 32.1575 56.973H13.2105C10.8851 56.973 9 55.0879 9 52.7625V12.7632C9 10.4378 10.8851 8.55273 13.2105 8.55273H25.8418",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9086 16.1399C42.9086 19.9171 39.8466 22.9792 36.0693 22.9792C32.292 22.9792 29.23 19.9171 29.23 16.1399C29.23 13.0334 33.8575 5.7824 35.4989 3.30656C35.6255 3.11514 35.8398 3 36.0693 3C36.2988 3 36.5131 3.11514 36.6397 3.30656C38.2825 5.78377 42.9086 13.0334 42.9086 16.1399Z",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.628 25.0072C42.7974 26.8795 39.4623 27.8422 36.0694 27.7662C32.6593 27.8436 29.3079 26.8704 26.4697 24.9785",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0339 27.1653C46.7133 30.3649 41.4438 32.0218 36.0695 31.8707C30.6635 32.0257 25.3642 30.3465 21.0339 27.1064",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLiquidExpose);
export default __webpack_public_path__ + "static/media/icon-liquid-expose.e387adaf.svg";
export { ForwardRef as ReactComponent };